<template lang="pug">
div
  p.title.small Payment option
  p.subtitle.light Pay via
  ul
    li
      label
        input.with-gap(
          name='paymentMode',
          type='radio',
          value='cash',
          v-model='paymentMode'
        )
        span Cash on delivery
    li
      label
        input.with-gap(
          name='paymentMode',
          type='radio',
          value='bank',
          v-model='paymentMode'
        )
        span Bank Deposit
</template>
<script>
import debounce from 'debounce'

export default {
  data () {
    return {
      onPaymentChange: debounce(this.changePayment, 500)
    }
  },
  computed: {
    paymentMode: {
      get () {
        return this.$store.state.cart.paymentMode
      },
      set (paymentMode) {
        this.onPaymentChange(paymentMode)
      }
    }
  },
  methods: {
    changePayment (paymentMode) {
      this.$store.dispatch('cart/setPaymentMode', paymentMode)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-cart-payment.vue